import { klwAxios } from "helpers/api";

export interface RapportageOpties {
  jaar: number;
  rapportGroepen: RapportOptiesGroep[];
}

export interface KringloopwijzerOptie {
  kringloopwijzerId: number;
  jaar: number;
  naam: string;
}

export interface RapportOptiesGroep {
  titel: string;
  rapporten: RapportOptie[];
}

export interface RapportOptie {
  naam: string;
  rapportageTypeId: number;
}

export interface RapportageDownloadRequest {
  kringloopwijzerId: number;
  rapportageTypeId: number;
}

export interface RapportageMailRequest extends RapportageDownloadRequest {
  emailAdressen: string[];
  naamAfzender: string;
}

export const getRapportageOpties = () =>
  klwAxios
    .get<RapportageOpties>("/Rapportage/GetRapportageOptiesVoorKringloopWijzer")
    .then((res) => res.data);

export const downloadRapportage = (request: RapportageDownloadRequest) =>
  klwAxios
    .post("/Rapportage/DownloadRapportageVoorKringloopWijzer", request)
    .then((res) => res.data);

export const mailRapportage = (request: RapportageMailRequest) =>
  klwAxios
    .post("/Rapportage/EmailRapportageVoorKringloopWijzer", request)
    .then((res) => res.data);

export const getRapportageOptiesVoorJaar = (klwId: number) =>
  klwAxios
    .get<RapportageOpties>("/Rapportage/GetHistorischeRapportageOptiesVoorKringloopwijzer?kringloopwijzerId=" + klwId)
    .then((res) => res.data);

export const getHistorischKringloopwijzerOpties = () =>
  klwAxios
    .get<KringloopwijzerOptie[]>("/Rapportage/GetHistorischeKringloopwijzerOpties")
    .then((res) => res.data);

export const downloadHistorischRapportage = (
  request: RapportageDownloadRequest
) =>
  klwAxios
    .post("/Rapportage/DownloadHistorischRapportage", request)
    .then((res) => res.data);
